"use client";
import { useTranslations } from 'next-intl';
import style from './actions.module.scss';
import ChosenFilters from '../chosen-filters/ChosenFilters';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';
import GridOneColumn from '@/projectRoot/src/components/common/svg/GridOneColumn';
import GridFourColumn from '@/projectRoot/src/components/common/svg/GridFourColumn';
import GridTwoColumn from '@/projectRoot/src/components/common/svg/GridTwoColumn';
import Select from '@/projectRoot/src/components/common/form-elements/select/Select';
import { GridDisplay } from '../filters-section/FiltersSection';
import { useEffect, useMemo, useState } from 'react';
import Drawer from '@/projectRoot/src/components/common/drawer/Drawer';
import { bodyDisableScroll } from '@/projectRoot/src/utils/handlers/miscHandler';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';
import { AvailableSortByProperties } from '@/projectRoot/api-client/interfaces/request/products/ProductsSearch.dto';

interface Props {
  classes?: string[];
  display: GridDisplay;
  onChooseDisplay: (display: GridDisplay) => void;
  products_length?: number;
}

const Actions = ({display, onChooseDisplay, products_length, classes = []}: Props) => {
  const t = useTranslations();
  const {isMobileView} = useGlobals();
  const {state, dispatch, setProductsCount, filters_count} = useFilters();
  const [openFilters, setOpenFilters] = useState<boolean>(false);
  const [sortByOption, setSortByOption] = useState<string>('sort_by');

  const onSelectSortBy = (option: AvailableSortByProperties) => {
    setSortByOption(option);
    dispatch({type: 'updateSortBy', payload: option});
  }

  const toggleFilters = (open: boolean) => {
    setOpenFilters(open);
    bodyDisableScroll(open);
  }

  useEffect(() => {
    if(state.sort_by){
      setSortByOption(state.sort_by);
    }else{
      setSortByOption('sort_by');
    }
  }, [state]);

  useEffect(() => {
    setProductsCount(filters_count > 0 ? products_length : 0);
  }, [products_length, filters_count]);

  return (
    <>
      <div className={`${style.actions} ${classes.join(' ')}`} id='filters_actions'>
          <p className={style.filtersOpener} onClick={() => toggleFilters(true)}>
            {t('filters')}
            {
              filters_count > 0
              ?
              <span className={style.count}>
                ({filters_count})
              </span>
              : <></>
            }
          </p>
          <ChosenFilters classes={[style.chosenFilters]} />
          <div className={style.layoutSortWrapper}>
            <div className={style.layoutOptions}>
              {
                isMobileView
                ?
                <span className={style.layoutOption} onClick={() => onChooseDisplay(GridDisplay.ONE)}>
                  <GridOneColumn fill={display == GridDisplay.ONE} hexColor={display == GridDisplay.ONE ? 'black' : 'white'} />
                </span>
                :
                <span className={style.layoutOption}  onClick={() => onChooseDisplay(GridDisplay.FOUR)}>
                  <GridFourColumn fill={display == GridDisplay.FOUR} hexColor={display == GridDisplay.FOUR ? 'black' : 'white'} />
                </span>
              }
              <span className={style.layoutOption}  onClick={() => onChooseDisplay(GridDisplay.TWO)}>
                <GridTwoColumn 
                  fill={display == GridDisplay.TWO} 
                  hexColor={display == GridDisplay.TWO ? 'black' : 'white'} 
                  width={isMobileView ? 16 : 20}
                  height={isMobileView ? 16 : 20}
                />
              </span>
            </div>
            <Select 
              classes={[style.sortingOptions]}
              hasBorder={false}
              onSelect={onSelectSortBy}
              selectedOption={sortByOption}
              translatableOptions
              idOptions={[
                AvailableSortByProperties.SORT_BY_RATING,
                AvailableSortByProperties.SORT_BY_CREATED_AT_DESC,
                AvailableSortByProperties.SORT_BY_PRICE_DESC,
                AvailableSortByProperties.SORT_BY_PRICE_ASC
              ].map(option => {return {id: option, name: option}})}
            />
          </div>
      </div>
      <Drawer 
        content={''}
        content_type='filters'
        showDrawer={openFilters}
        onCloseDrawer={() => toggleFilters(false)}
        title={t('filters')}
        content_position='left'
      />
    </>
  )
};

export default Actions;
